<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleClick"
      >
        <el-tab-pane v-if="$route.params.redisKey" :label="$t('CargoMsg.AutomaticReconciliation')" name="automaticReconciliation" :lazy="true">
          <tab-automatic-reconciliation />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.AutomaticReconciliationHistory')" name="automaticReconciliationHistory" :lazy="true">
          <tab-automatic-reconciliation-history ref="automaticReconciliationHistory" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabAutomaticReconciliation from '@/views/cargo/v0/Clearing/AutomaticReconciliation/components/tabAutomaticReconciliation'
import TabAutomaticReconciliationHistory from '@/views/cargo/v0/Clearing/AutomaticReconciliation/components/tabAutomaticReconciliationHistory'
export default {
  name: 'AutomaticReconciliation',
  components: { TabAutomaticReconciliationHistory, TabAutomaticReconciliation },
  data() {
    return {
      activeTabName: ''
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.name === 'AutomaticReconciliation') {
          this.activeTabName = this.$route.params.name
        }
      }
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.name === 'automaticReconciliationHistory') {
        this.$nextTick(() => {
          this.$refs.automaticReconciliationHistory.toQuery()
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
